import { createContext, useContext } from 'react';

interface StepProgressBarContextType {
    activeStep?: number;
    isComplete?: boolean;
    index: number;
}

export const StepProgressBarContext = createContext<StepProgressBarContextType | undefined>(undefined);

export const useStepProgressBarContext = () => {
    const context = useContext(StepProgressBarContext);
    if (!context) {
        throw new Error('StepProgressBar compound components must be used within StepProgressBar');
    }
    return context;
};
